module.exports = __webpack_public_path__ + "img/468906963_453815597739348_2617730140183771887_n.6f29c447.jpg";